export const ErrorTexts = {
  USER_ALREADY_EXISTS: 'User already exists',
};